export const TRIP_TYPES = ['Full', 'Partial', 'Cancel']

export const SHIP_CODE = ['IRO', 'CVC', 'SNL', 'KGN', 'CARP', 'GAN', 'MOR', 'PRS', 'PRSA', 'WSH', 'Other']

export const PROD_HEADER = ['Report', 'User Trips']

export const REPORT_HEADER = ['Productivity', 'Assignments', 'Summary', 'Availability']

export const MONTHS = ['Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// export const MONTHS_ABBR = ['apr', 'may', 'jun', 'july', 'aug', 'sep', 'oct', 'nov', 'dec']

export const DETAIL_ASSIGNMENT = ['Full', 'Partial', 'Cancel', 'Total Assignments', 'Auth & Corp', 'TOTAL', 'Amount Shared', 'Double']
